import styles from './FJFaceSwapLeftRight.module.less';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationPanelContainer from '../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import classNames from 'classnames';
import FJImageToVideoButtonContainer from '../../../common/combineComponents/FJImageToVideoButtonContainer/container/FJImageToVideoButtonContainer.jsx';
import FJConstant from '../../../constants/FJConstant';

const FJFaceSwapLeftRight = () => {
    const renderRightChildren = () => {
        if (window.isEditPage) return null; // 使用内部的download组件
        return <FJImageToVideoButtonContainer />;
    };
    return (
        <div className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer isShowProgress={false} rightChildren={renderRightChildren()} />

            <FJCreationPanelContainer activeHeaderTabIndex={FJConstant.CREATIONS} />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </div>
    );
};

export default FJFaceSwapLeftRight;
